export enum HeaderFooterVariant {
  Default = 'default',
  ECS = 'ecs',
}
